import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import withFloatingFormControlFocus from '../../input/focus/withFloatingFormControlFocus';

/**
 * This component is basically a shim to maintain floating form focus behavior
 * in the V2 component while we phase out the V1 component. Once V1 is totally
 * phased out we can take a more complete look at how we want focus to work
 * and refactor.
 */
const LeafInput = (_ref) => {
  let {
    InputComponent
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["InputComponent"]);

  return /*#__PURE__*/_jsx(InputComponent, Object.assign({}, props));
};

export default withFloatingFormControlFocus(LeafInput);